<div style="margin-top: 20px" *ngIf="form">
    <div>
        <h4>Detalhes do form</h4>
    </div>
<pre>
Form válido: {{ form.valid }}
</pre>
<pre>
Form submetido: {{ form.submitted }}
</pre>
<pre>
Form valores:<br>{{ form.value | json }}
</pre>
</div>